export default __webpack_public_path__ + "static/media/playfair-display-v22-latin-regular.3f5779de.woff";